import { SVGInterface } from "../../interface";

const Contrast = ({ color, ...rest }: SVGInterface) => (
  <svg
    width="24"
    height="24"
    viewBox="0 0 24 24"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    {...rest}
  >
    <path
      d="M12 22C17.52 22 22 17.52 22 12C22 6.48 17.52 2 12 2C6.48 2 2 6.48 2 12C2 17.52 6.48 22 12 22ZM13 4.07C16.94 4.56 20 7.92 20 12C20 16.08 16.95 19.44 13 19.93V4.07Z"
      fill={color || "#0E171F"}
    />
  </svg>
);

export default Contrast;
